import * as React from 'react';
import { Component } from 'react';
import { action, computed, observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Tabs from './Tabs';
import Tab from './Tab';
import Chart from './Chart';

const ChartsWrapper = styled<any, any>('div')`
    ${propStyles};
`;

ChartsWrapper.defaultProps = {
    marginY: 'lg',
};

const ChartsHeader = styled<any, any>('h2')`
    ${propStyles};
`;

ChartsHeader.defaultProps = {
    color: 'body',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: 'md',
};

@inject('dataStore')
@observer
class Charts extends Component<any, any> {
    @observable selectedChartId;

    @computed
    get groupedCharts() {
        return this.props.charts.filter(chart => chart.grouped);
    }

    @computed
    get selectedChart() {
        return this.groupedCharts.find(chart =>
            this.selectedChartId
                ? chart.id === this.selectedChartId
                : chart.selected
        );
    }

    @computed
    get ungroupedCharts() {
        return this.props.charts.filter(chart => !chart.grouped);
    }

    @action
    selectChartId = id => {
        this.selectedChartId = id;
    };

    render() {
        const {
            groupedCharts,
            selectedChart,
            ungroupedCharts,
            selectChartId,
        } = this;

        const { theme, shareClass, chartsHeader, queryContext } = this.props;

        return (
            <ChartsWrapper {...theme.ChartsWrapper}>
                {chartsHeader && (
                    <ChartsHeader {...theme.ChartsHeader}>
                        {chartsHeader}
                    </ChartsHeader>
                )}
                <Tabs {...theme.ChartTabs}>
                    {groupedCharts.map((chart, index) => (
                        <Tab
                            key={chart.id}
                            isSelected={chart.id === selectedChart.id}
                            onClick={() => selectChartId(chart.id)}
                            {...theme.ChartTab}
                        >
                            {chart.label}
                        </Tab>
                    ))}
                </Tabs>

                {groupedCharts.length > 0 && (
                    <Chart
                        chart={selectedChart}
                        shareClass={shareClass}
                        queryContext={queryContext}
                    />
                )}

                {ungroupedCharts.map(chart => (
                    <Chart
                        key={chart.id}
                        chart={chart}
                        shareClass={shareClass}
                        showHeading={true}
                        queryContext={queryContext}
                    />
                ))}
            </ChartsWrapper>
        );
    }
}

export default withTheme(Charts) as any;



// WEBPACK FOOTER //
// ./src/Components/Charts.tsx